import { Grid } from "@mui/material";
import { LineChart } from "../../../components/chart/charts";
import { AreaChartByDate } from "src/types/types";

type DashboardLineChartPropsType = {
  data: AreaChartByDate;
};

const DashboardAreaChart = ({ data }: DashboardLineChartPropsType) => {
  return (
    <LineChart
      style={{ width: "100%" }}
      subheader=""
      chart={{
        categories: [...(data?.content?.xAxis || "")],
        series: [
          {
            data: [
              {
                name: "",
                data: [...(data?.content?.yAxis || "")],
              },
            ],
          },
        ],
        colors: ["#FFAB00"],
        options: {
          fill: {
            gradient: {
              opacityFrom: 0.5,
              opacityTo: 0.2,
            },
          },
          stroke: {
            width: 2,
          },
        },
      }}
    />
  );
};

export default DashboardAreaChart;
